import { useBlocker, useNavigate } from "react-router-dom";

import { useConfirm } from "./confirm/confirm.hooks";
import { ConfirmOptions } from "./common";
import { useCallback, useEffect } from "react";
import Alert from "../design-system/Alert";

export const usePrompt = ({
    when = false,
    title = "You have unsaved changes!",
    subtitle = "Are you sure you want to leave?",
    confirmText = "Leave",
    cancelText = "Stay",
    onConfirm,
    onCancel,
    type = "warning"
}: ConfirmOptions & { when?: boolean }) => {
    const blocker = useBlocker(when);

    const { show } = useConfirm();

    const confirm = useCallback(() => {
        if (!when) return Promise.resolve(true);

        return new Promise<boolean>(resolve => {
            show({
                title,
                subtitle,
                confirmText,
                cancelText,
                type,
                onConfirm: () => {
                    // localStorage.removeItem("1718773933547Decision Point 1")
                    resolve(true);
                    onConfirm?.();
                },
                onCancel: () => {
                    // localStorage.removeItem("1718773933547Decision Point 1")

                    resolve(false);
                    onCancel?.();
                }
            });
        });
    }, [cancelText, confirmText, when, onCancel, onConfirm, show, subtitle, title, type]);

  useEffect(() => {
    // console.log("blocker: ", blocker)
    if (blocker.state === 'blocked' ) {
      confirm().then((result) => {
        if (result) blocker.proceed();
        else blocker.reset();
      });
    }
  }, [blocker, confirm]);

    // useEffect(() => {
    //     if (when) {
    //         window.onbeforeunload = (e) => {
    //             // for (var key of Object.keys(localStorage)) {
    //             //     if (key.includes("Decision Point")) {
    //             //         localStorage.removeItem(key);
    //             //     }
    //             // }
                
    //             // console.log("dkskfjgsd: ",e.preventDefault())
    //             return subtitle;
    //         };
    //     }

    //     return () => {
    //         window.onbeforeunload = null;
    //     };
    // }, [when, subtitle]);


    return {
        confirm
    };
};
